<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <template v-else>
      <px-aprovacao-solicitacao-item v-for="aprovacao in aprovacoes.content"
                                     :key="aprovacao.id"
                                     :aprovacao="aprovacao"
                                     @update="onUpdateItem"
                                     class="mt-5"/>
      <template v-if="!loading && !aprovacoes.content.length">
        <div align="center" class="heading mt-5">
          Nenhuma solicitação encontrada
        </div>
      </template>
      <v-pagination
        class="mt-3"
        v-model="page"
        :length="pagesLimit"
        :total-visible="5"
      ></v-pagination>
    </template>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
  RESET_PAGINATION,
} from '@/store/listagem-aprovacao-solicitacao/actions.type';
import AprovacaoSolicitacaoItem from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoItem.vue';
import AprovacaoSolicitacaoService
  from '@/modules/aprovacao-solicitacao/aprovacao-solicitacao-service';
import paginationMixin from '@/mixins/pagination-mixin';
import { situacaoAprovacaoUser } from '@/modules/aprovacao-solicitacao/aprovador-solicitacao-utils';

const LIMIT = 20;
const PAGE = 1;

export default {
  mixins: [paginationMixin],
  data() {
    return {
      page: PAGE,
      pagesLimit: 1,
      loading: false,
      aprovacoes: {
        content: [],
      },
      optionsList: {
        page: PAGE,
        itemsPerPage: LIMIT,
        sortBy: '',
        sortDesc: false,
        multiSort: false,
      },
    };
  },
  computed: {
    ...mapGetters('listagemAprovacaoSolicitacao', ['selectedStatus', 'stringFilter', 'listOptions']),
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
  },
  methods: {
    ...mapActions('listagemAprovacaoSolicitacao', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    refresh() {
      this.getAprovacoes();
    },
    onChangeFilters() {
      this.resetPagination();
      this.page = PAGE;
      this.getAprovacoes();
    },
    onChangeOptions() {
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getAprovacoes();
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.aprovacoes.total / LIMIT);
    },
    getAprovacoes() {
      this.loading = true;

      this.updateFilter(this.stringFilter);

      const { limit, offset } = this.listOptions;
      const situacao = this.selectedStatus ? this.selectedStatus.value : null;

      AprovacaoSolicitacaoService.getList(
        {
          query: this.buildQuery(this.listOptions),
          limit,
          offset,
          situacao,
        },
      )
        .then(({ data }) => {
          this.aprovacoes = data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
    onUpdateItem(aprovacaoAtualizada) {
      const findOldItem = this.aprovacoes.content
        .find(item => item.id === aprovacaoAtualizada.id);

      // o item antigo pode não estar na lista quando carregamos ele pelo query param
      if (!findOldItem) {
        this.getAprovacoes();
        return;
      }
      const newItemSituacaoUsuario = situacaoAprovacaoUser(this.user, aprovacaoAtualizada);
      const isSituacaoDiferente = findOldItem.situacao !== newItemSituacaoUsuario
        || findOldItem.situacao !== aprovacaoAtualizada.situacao;
      if (isSituacaoDiferente) {
        this.getAprovacoes();
        return;
      }
      this.aprovacoes.content = this.aprovacoes.content.map((item) => {
        if (item.id === aprovacaoAtualizada.id) {
          return aprovacaoAtualizada;
        }
        return item;
      });
    },
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.getAprovacoes();
  },
  components: {
    pxAprovacaoSolicitacaoItem: AprovacaoSolicitacaoItem,
  },
};
</script>
